import { takeLatest, call, put } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";

import Api from "../utils/api";

function* confirmationSaga({ payload }) {
  try {
    yield call(Api.post, "/authen/confirmation", payload);
    yield put(setIsSuccess(true));
  } catch (err) {
    console.log(err);
    if (err.response.data) {
      yield put(setError(err.response.data.message));
    }
  }
}

export function* watchConfirmationSaga() {
  yield takeLatest(onConfirmation.type, confirmationSaga);
}

export const confirmationSlice = createSlice({
  name: "confirmation",
  initialState: {
    isSuccess: false,
    errorMessage: "",
  },
  reducers: {
    onConfirmation: () => {},
    setIsSuccess: (state, action) => {
      state.isSuccess = action.payload;
    },
    setError: (state, action) => {
      state.errorMessage = action.payload;
    },
  },
});

export const { onConfirmation, setIsSuccess, setError } =
  confirmationSlice.actions;

export default confirmationSlice.reducer;
